import React from "react";
import { useApp } from "../../context/AppContext";
import { financeStats, fmtMoney, fmtMoneyShort } from "../../lib/appUtils";
import { TEAMS, PAY_STAGES } from "../../data/constants";
import { AreaChart, Area, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar, Legend } from "recharts";

const TEAM_COLORS = ["#4F6BFF", "#7B5CFF", "#06b6d4", "#10b981", "#f59e0b"];

export default function CollectionsCharts({ projects }) {
  const { lang } = useApp();
  const zh = lang === "zh";
  const byTeam = TEAMS.map((tm, i) => {
    const s = financeStats(projects.filter((p) => p.team === tm.id));
    return { name: zh ? tm.zh : tm.name, collected: s.collected, receivable: s.receivable, color: TEAM_COLORS[i % 5] };
  }).filter((r) => r.collected || r.receivable);
  const byStage = PAY_STAGES.map((st) => {
    let paid = 0, due = 0;
    projects.forEach((p) => (p.payments || []).forEach((pay) => {
      if (pay.stage === st.key) { if (pay.status === "paid") paid += pay.amount; else due += pay.amount; }
    }));
    return { name: zh ? st.zh : st.en, paid, due };
  });
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="cockpit-collections">
      <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="cockpit-collections-team">
        <h3 className="font-semibold text-slate-900 mb-4">{zh ? "各小组收款 / 应收" : "Collections vs Receivables by Team"}</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={byTeam} margin={{ top: 6, right: 6, left: -8, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f7" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#64748b" }} />
            <YAxis tickFormatter={fmtMoneyShort} tick={{ fontSize: 11, fill: "#64748b" }} />
            <Tooltip formatter={(v) => fmtMoney(v)} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="collected" name={zh ? "已收款" : "Collected"} fill="#16a34a" radius={[5, 5, 0, 0]} />
            <Bar dataKey="receivable" name={zh ? "应收" : "Receivable"} fill="#4F6BFF" radius={[5, 5, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid="cockpit-collections-stage">
        <h3 className="font-semibold text-slate-900 mb-4">{zh ? "各收款节点已收/待收" : "Collection by Milestone"}</h3>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={byStage} margin={{ top: 6, right: 6, left: -8, bottom: 40 }}>
            <defs>
              <linearGradient id="ckPaid" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#16a34a" stopOpacity={0.5} /><stop offset="100%" stopColor="#16a34a" stopOpacity={0.05} /></linearGradient>
              <linearGradient id="ckDue" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#d97706" stopOpacity={0.5} /><stop offset="100%" stopColor="#d97706" stopOpacity={0.05} /></linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f7" />
            <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#64748b" }} angle={-30} textAnchor="end" interval={0} />
            <YAxis tickFormatter={fmtMoneyShort} tick={{ fontSize: 11, fill: "#64748b" }} />
            <Tooltip formatter={(v) => fmtMoney(v)} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Area type="monotone" dataKey="paid" name={zh ? "已收款" : "Collected"} stroke="#16a34a" fill="url(#ckPaid)" strokeWidth={2} />
            <Area type="monotone" dataKey="due" name={zh ? "待收款" : "Pending"} stroke="#d97706" fill="url(#ckDue)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
